import type { GroupId, SpaceSnapshot } from '../types';

interface SidePickerProps {
  snapshot: SpaceSnapshot;
  onPick: (group: GroupId) => void;
}

export function SidePicker({ snapshot, onPick }: SidePickerProps) {
  return (
    <section className="card sidePicker">
      <span className="eyebrow">Private stance</span>
      <h2>Which pull do you feel more often?</h2>
      <p>Your side is only used for aggregation. No account. No public profile. No feed algorithm goblin. 🫡</p>
      <div className="sideButtons">
        <button onClick={() => onPick('A')}>
          <span>A</span>
          {snapshot.space.groupALabel}
        </button>
        <button onClick={() => onPick('B')}>
          <span>B</span>
          {snapshot.space.groupBLabel}
        </button>
      </div>
    </section>
  );
}
